const SET_DATERANGE = (state, payload) => {
    state.dateRange = [payload[0], payload[1]]
}

export default {
    SET_DATERANGE
}
